import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';

import { ProjectsService } from 'app/modules/projects/projects.service';
import { Project, ProjectTemplate, Property, Address } from 'app/modules/projects/projects.types';
import { ProjectType, PropertyType, ProjectStage, FieldDef } from 'app/core/models/account.types';
import { PropertiesService } from '../../properties.service';

@Component({
  selector: 'property-add-address',
  templateUrl: './property-add-address.component.html',
  styleUrls: ['./property-add-address.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PropertyAddAddressComponent implements OnInit {
  addProjectForm: UntypedFormGroup;
  addProjectByUrlForm: UntypedFormGroup;
  fieldDefs: FieldDef[] = [];
  project: Project;
  displayColumns: any[];
  options: [];
  projectTypes: ProjectType[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];
  projectTemplates: ProjectTemplate<any>[];
  isDealsDetailView: boolean = true;
  duplicateProjectId: number = 0;
  duplicateProjects: Project[] = [];
  duplicateAddressProjects: Project[] = [];

  private _unsubscribeAll: Subject<void>;
  public uploadedFile: any;
  property: Property;
  address: Address;

  /**
   * Constructor
   *
   * @param {MatDialogRef} matDialogRef
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<PropertyAddAddressComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    private _projectsService: ProjectsService,
    private _propertiesService: PropertiesService,
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.addProjectForm = this._formBuilder.group({
      id: '',
      address_string: '',
      street: '',
      city: [''],
      state: '',
      postal_code: '',
      latitude: '',
      longitude: '',
      addressable_id: '',
      addressable_type: '',
    });

    this.property = this.data.property;
    this.addProjectForm.get('addressable_id').setValue(this.data.property.id);
    this.addProjectForm.get('addressable_type').setValue('Property');

    if (this.data.address) {
      this.address = this.data.address;
      this.addProjectForm.patchValue(this.address);
    }
  }

  onFileChanged($event) {
    let file = $event.target.files[0];
    this.uploadedFile = file;
  }

  setAddressParts(addressParts) {
    this.addProjectForm.get('city').setValue(addressParts.locality || addressParts.sublocality_level_1);
    this.addProjectForm.get('state').setValue(addressParts.administrative_area_level_1);
    this.addProjectForm.get('postal_code').setValue(addressParts.postal_code);
    if (addressParts.street_number && addressParts.route) {
      this.addProjectForm.get('street').setValue(addressParts.street_number + ' ' + addressParts.route);
    } else if (!addressParts.street_number && addressParts.route) {
      this.addProjectForm.get('street').setValue(addressParts.route);
    } else {
      this.addProjectForm.get('street').setValue('');
    }
    this.addProjectForm.get('latitude').setValue(addressParts.lat);
    this.addProjectForm.get('longitude').setValue(addressParts.lng);

    this._changeDetectorRef.detectChanges();

    // since blur doesn't work for google-places, we need to call it manually
    // this.addressBlur();
  }

  setAddress(addressString) {
    // this.projectForm.get('deal').get('property').get('address').get('address_string').setValue(addressString);
  }

  goToDeal(): void {
    this._router.navigateByUrl('/projects/' + this.project.pipeline_id + '/' + this.project.id + '/details/overview');
    this.discard();
  }

  goToProject(project): void {
    this._router.navigateByUrl('/projects/' + project.pipeline_id + '/' + project.id + '/details/overview');
    this.discard();
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Send the message
   */
  save(): void {
    this.addProjectForm.disable();

    let address = this.addProjectForm.value;
    this._propertiesService.updatePropertyAddress(address, this.property.id).subscribe((address) => {
      this.isDealsDetailView = false;
      this._propertiesService.getPropertyById(this.property.id.toString()).subscribe();
      this.matDialogRef.close({ address: address });
    });
  }

  updated() {
    this._projectsService.saveProject(this.project).subscribe();
  }

  lookupField(name) {
    let fields = this.fieldDefs.filter((fieldDef) => fieldDef.name == name);
    if (fields.length > 0) {
      return fields[0];
    } else {
      return null;
    }
  }
}
